import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { numberWithCommas, takeOneDecimal } from '../../util/CommonUtils';
import { splitLabel } from '../../util/SalesCatalystUtils';
import {
  COMPETITION_TEXT_COLOR,
  COMPETITION_DEFAULT_BACKGROUND_COLOR,
} from '../../constants';
import closeIcon from '../../images/salescatalyst/CloseIcon.png';
import closeIconWhite from '../../images/salescatalyst/closeiconWhite.png';
import editIcon from '../../images/salescatalyst/EditIcon.png';
import editIconWhite from '../../images/salescatalyst/editiconWhite.png';

class SalesCatalysBoxtInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInEditMode: false,
      headerLabelUpdateObject: {},
      headerLabelUpdateCallBack: '',
      index: null,
      popupCloseButtonClick: true,
    };
  }

  displayTitle = data => {
    const { defaultHeader } = this.props;
    let title;
    if (typeof (data) === 'undefined') {
      title = defaultHeader;
      return title;
    }
    if (typeof (data.title) === 'undefined') {
      title = data.label;
      return title;
    }
    return data.title;
  }

  clickableBoxInput = () => {
    const { defaultHeader, data, backgroundColor,
      color, dataOnScreen, deleteHandler, field,
      subCategory, index, showDeleteButton,
      showEditButton, clickBoxDefaultTitle, children } = _.clone(this.props);
    return (
      <div
        className="row sales-catalyst-box-input-clickable"
        style={{ backgroundColor, color }}
        title={clickBoxDefaultTitle}
        onClick={() => {
          this.props.clickEventFunction();
        }}
      >
        {(typeof (data) !== 'undefined') && <div className="large-12 medium-12 small-12 columns icon-block">
          <div className="sc-box-input-edit-block">
            {(showEditButton) && <img
              className="sc_delete_icons_img size-md"
              src={(!dataOnScreen) ? editIcon : editIconWhite}
              alt="Edit"
              title="Edit"
              onClick={() => {
                this.props.toggleEditMode(subCategory, index, defaultHeader, true);
              }}
            />}
            {(showDeleteButton) && <img
              className="sc_delete_icons_img size-lg"
              src={(!dataOnScreen) ? closeIcon : closeIconWhite}
              alt="Delete"
              title="Delete"
              onClick={() => { deleteHandler(field, subCategory, index); }}
            />}
          </div>
        </div>}
        <div
          className="large-12 medium-12 small-12 columns sales-catalyst-box-input-header"
          style={{ marginTop: (typeof (data) === 'undefined') ? '4.8%' : '' }}
        >
          <span
            className="bold"
            style={{ fontSize: '13pt' }}
            title={this.displayTitle(data)}
          >
            {(typeof (data) === 'undefined') ? defaultHeader : splitLabel(data.label)}
          </span>
          {(typeof (children) !== 'undefined') &&
            children
          }
        </div>
        <div className="large-12 medium-12 small-12 columns sales-catalyst-box-input-header">
          <span className="bold" style={{ fontSize: '14pt' }}>
            {(typeof (data) === 'undefined') ? '' : `${takeOneDecimal((data.reach || data.pct), 1)}`}
          </span>
        </div>
        <div className="large-12 medium-12 small-12 columns sales-catalyst-box-input-header">
          {(typeof (data) !== 'undefined') && (typeof (data.weighted) !== 'undefined') &&
            <div className="row sc-sample-weighted-content">
              <span className="">SAMPLE : </span>
              <span className="bold">{numberWithCommas(
                Math.round(data.sample || data.intab))}</span>
              <span>|</span>
              <span className="">WEIGHTED : </span>
              <span className="bold">{numberWithCommas(
                Math.round(data.weighted))}</span>
            </div>}
        </div>
      </div>
    );
  }

  nonClickableBoxInput = () => {
    const { defaultHeader, data, backgroundColor,
      color, dataOnScreen, deleteHandler, field,
      subCategory, index, showDeleteButton,
      showEditButton } = _.clone(this.props);
    return (
      <div
        className="row sales-catalyst-box-input"
        style={{ backgroundColor, color }}
      >
        {(typeof (data) !== 'undefined') && <div className="large-12 medium-12 small-12 columns icon-block">
          <div className="sc-box-input-edit-block">
            {(showEditButton) && <img
              className="sc_delete_icons_img size-md"
              src={(!dataOnScreen) ? editIcon : editIconWhite}
              alt="Edit"
              title="Edit"
              onClick={() => {
                this.props.toggleEditMode(subCategory, index, defaultHeader, true);
              }}
            />}
            {(showDeleteButton) && <img
              className="sc_delete_icons_img size-lg"
              src={(!dataOnScreen) ? closeIcon : closeIconWhite}
              alt="Delete"
              title="Delete"
              onClick={() => { deleteHandler(field, subCategory, index); }}
            />}
          </div>
        </div>}
        <div
          className="large-12 medium-12 small-12 columns sales-catalyst-box-input-header"
          style={{ marginTop: (typeof (data) === 'undefined') ? '4.8%' : '' }}
        >
          <span
            className="bold"
            style={{ fontSize: '13pt' }}
            title={this.displayTitle(data)}
          >
            {(typeof (data) === 'undefined') ? defaultHeader : splitLabel(data.label)}
          </span>
        </div>
        <div className="large-12 medium-12 small-12 columns sales-catalyst-box-input-header">
          <span className="bold" style={{ fontSize: '14pt' }}>
            {(typeof (data) === 'undefined') ? '' : `${takeOneDecimal((data.reach || data.pct), 1)}`}
          </span>
        </div>
        <div className="large-12 medium-12 small-12 columns sales-catalyst-box-input-header">
          {(typeof (data) !== 'undefined') && (typeof (data.weighted) !== 'undefined') &&
            <div className="row sc-sample-weighted-content">
              <span className="">SAMPLE : </span>
              <span className="bold">{numberWithCommas(
                Math.round(data.sample || data.intab))}</span>
              <span>|</span>
              <span className="">WEIGHTED : </span>
              <span className="bold">{numberWithCommas(
                Math.round(data.weighted))}</span>
            </div>}
        </div>
      </div>
    );
  }

  render() {
    return (this.props.showClickableBoxInput) ? this.clickableBoxInput()
      : this.nonClickableBoxInput();
  }
}

SalesCatalysBoxtInput.propTypes = {
  clickEventFunction: PropTypes.func,
  showClickableBoxInput: PropTypes.bool,
};

SalesCatalysBoxtInput.defaultProps = {
  backgroundColor: COMPETITION_DEFAULT_BACKGROUND_COLOR,
  color: COMPETITION_TEXT_COLOR,
  showDeleteButton: true,
  showEditButton: true,
  showClickableBoxInput: false,
  clickBoxDefaultTitle: '',
};
function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  // const { dispatch } = dispatchProps;
  return Object.assign({}, stateProps, ownProps, {
  });
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalysBoxtInput);
